// ----------------------------------------------------------------------------
// Optional Feature: Sticky Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_header--sticky.scss';

// -------------------------------------
// Variables
// -------------------------------------
var lastScrollTop = 0;
var ticking = false;
var isStickyActive = false;

// Selectors
var HEADER_SELECTOR = '#shopify-section-header';
var PRODUCT_SECTION = '#shopify-section-product';

// Classes
var STICKY_CLASS = 'is-sticky';
var HIDDEN_CLASS = 'is-hidden';

// Config
var SCROLL_DELTA_THRESHOLD = 5;
var HEADER_HEIGHT_THRESHOLD = 100;

// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  var headerSection = document.querySelector(HEADER_SELECTOR);
  var productSection = document.querySelector(PRODUCT_SECTION);

  // Bail if sticky header shouldn't run (e.g. product template or missing header)
  if (!headerSection || productSection) return;
  var _headerHeight = headerSection.offsetHeight;
  var measureHeaderHeight = () => {
    _headerHeight = headerSection.offsetHeight;
  };
  var activateSticky = () => {
    if (isStickyActive) return;
    headerSection.classList.add(STICKY_CLASS);
    headerSection.classList.remove(HIDDEN_CLASS);
    isStickyActive = true;
  };
  var resetHeader = () => {
    headerSection.classList.remove(STICKY_CLASS, HIDDEN_CLASS);
    isStickyActive = false;
  };
  var updateHeaderState = () => {
    var currentScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
    var scrollDelta = Math.abs(currentScroll - lastScrollTop);
    var bodyHasNoScroll = document.body.classList.contains('noscroll');
    var scrollingDown = currentScroll > lastScrollTop;

    // Always show header when menu is open
    if (bodyHasNoScroll) {
      activateSticky();
      headerSection.classList.remove(HIDDEN_CLASS);
      lastScrollTop = currentScroll;
      return;
    }

    // Reset to normal state when near top
    if (currentScroll <= HEADER_HEIGHT_THRESHOLD) {
      resetHeader();
      lastScrollTop = currentScroll;
      return;
    }

    // Activate sticky state once we've scrolled past threshold
    if (!isStickyActive) {
      activateSticky();
    }

    // Only toggle visibility if scroll delta is significant to prevent flicker
    if (scrollDelta > SCROLL_DELTA_THRESHOLD) {
      if (scrollingDown) {
        headerSection.classList.add(HIDDEN_CLASS);
      } else {
        headerSection.classList.remove(HIDDEN_CLASS);
      }
    }
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  };

  // Throttle scroll events with requestAnimationFrame
  document.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(() => {
        updateHeaderState();
        ticking = false;
      });
    }
  }, {
    passive: true
  });

  // Recalculate header height on resize
  window.addEventListener('resize', () => {
    measureHeaderHeight();
    updateHeaderState();
  });
});